module.exports = {
  "userInteraction": {
    "name": "user interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string"
      },
      "app": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "growth-onboarding-empty-states",
    "version": "1"
  },
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": {
        "type": "string"
      },
      "app": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "growth-onboarding-empty-states",
    "version": "1"
  }
};